export const APP_VERSION: number = 704;
